
import { useGetProjectInstallationsQuery } from 'generated/graphql';
import _ from 'lodash';

import React from 'react';

export interface IData {
  id: string;
  type: string;
  numberOfActiveDecisionsInstallations: number;
  numberOfApprovedInstallations: number;
}



export function useQuery(projectId: string) {
  const tuple = useGetProjectInstallationsQuery({
    variables: {
      projectId: projectId
    },
    skip: projectId === ''
  });


  return React.useMemo(
    () => {
      const rawInstallations = tuple.data?.project?.installations;
      const installations: Record<string, typeof rawInstallations> = _.groupBy(tuple.data?.project?.installations, (node) => node.installationType.name);

      const keys = _.keys(installations);



      const data: IData[] = keys?.map((node) => {
        const installationsForType = installations[node];
        let id = '';
        let typeName = '';
        let numberOfActiveDecisionsInstallations = 0;
        let numberOfApprovedInstallations = 0;
        if (installationsForType && installationsForType[0]) {
          id = installationsForType[0].installationType.id;
          typeName = installationsForType[0].installationType.displayName;
          numberOfActiveDecisionsInstallations = installationsForType.filter((node) => !node.isComplete).length ?? 0,
          numberOfApprovedInstallations = installationsForType.filter((node) => node.isComplete).length ?? 0;
        }
        return {
          id: id,
          type: typeName,
          numberOfActiveDecisionsInstallations: numberOfActiveDecisionsInstallations,
          numberOfApprovedInstallations: numberOfApprovedInstallations
        };
      }) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
